import { render, staticRenderFns } from "./loanRecord.vue?vue&type=template&id=4c2026c8&scoped=true"
import script from "./loanRecord.vue?vue&type=script&lang=js"
export * from "./loanRecord.vue?vue&type=script&lang=js"
import style0 from "./loanRecord.vue?vue&type=style&index=0&id=4c2026c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2026c8",
  null
  
)

export default component.exports